"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        this.state = {
            users: [],
            fetching: false,
            more: false,
            suggestions: []
        };
    },
    onMount: function () {
        this.fetchUsers();
    },
    onDisplayUser: function (dataset) {
    },
    fetchUsers: async function () {
        try {
            this.state.fetching = true;
            const {error, message, results, more} = await Request(this.state.more || '/user/list');
            if (error)
                return console.log('Error Fetching Users: ', message);
            if (more) {
                this.state.more = more;
                this.state.users = [
                    ...this.state.users,
                    ...results
                ];
            }
            this.state.users = results.map(({profile, account, datetime}) => {
                return {
                    _email: profile.email,
                    photo: profile.photo,
                    name: getFullname(profile),
                    contacts: profile.email + (profile.phone ? ', ' + profile.phone : ''),
                    location: profile.country && profile.country.city ? profile.country.city + ', ' + profile.country.country_name : '-',
                    type: account.types.join(' - '),
                    status: !account.hasOwnProperty('verification') ? 'Verified' : 'No Verified',
                    datetime: formatDate(datetime, 'calendar')
                };
            });
        } catch (error) {
            console.log('Error Fetchint Users: ', error);
        }
        this.state.fetching = false;
    },
    onSearchResult: function (results) {
        this.state.suggestions = results.map(({profile, account}) => {
            return {
                poster: {
                    type: 'image',
                    value: profile.photo
                },
                title: profile.first_name + ' ' + profile.last_name,
                subtitle: profile.email,
                status: account.types.join(', ')
            };
        });
    },
    onSearchDismiss: function () {
        this.state.suggestions = [];
    },
    onSelectSuggestion: function (index) {
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Users/Admin/index.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    SearchBar_template = require("../../../../components/SearchBar/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    SearchBar_tag = marko_loadTag(SearchBar_template),
    WSAdapt_template = require("../../../../components/WSAdapt/index.marko"),
    WSAdapt_tag = marko_loadTag(WSAdapt_template),
    Locale_template = require("../../../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    route_link_template = require("marko-router5/src/components/route-link/index.marko"),
    route_link_tag = marko_loadTag(route_link_template),
    Datatable_template = require("../../../components/Datatable/index.marko"),
    Datatable_tag = marko_loadTag(Datatable_template),
    Row_template = require("../../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    Wrapper_Admin_template = require("../../../components/Wrapper-Admin.marko"),
    Wrapper_Admin_tag = marko_loadTag(Wrapper_Admin_template),
    marko_attrs0 = {
        "class": "col-12"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("d98375"),
    marko_node0 = marko_createElement("br", null, "12", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node1 = marko_createElement("br", null, "13", null, 0, 0, {
        i: marko_const_nextId()
      });

const tableFormat = [
	{ key: 'trindex', label: '#', col: '1' },
	{ key: 'photo', label: 'Photo', type: 'image', col: '1' },
	{ key: 'name', label: 'Name' },
	{ key: 'contacts', label: 'Contacts' },
	{ key: 'location', label: 'From' },
	{ key: 'type', label: 'Account Type', wsadapt: { hs: 'd-none' } },
	{ key: 'status', label: 'Account Status', wsadapt: { hs: 'd-none' }, style: 'text-primary' },
	{ key: 'datetime', label: 'Date Joined', wsadapt: { qs: 'd-none', hs: 'd-none' } }
];

function render(input, out, __component, component, state) {
  var data = input;

  Wrapper_Admin_tag({
      renderBody: function(out) {
        Row_tag({
            class: "m-0",
            renderBody: function(out) {
              WSAdapt_tag({
                  ns: "col-md-5 col-12",
                  qs: "col-md-7 col-12",
                  hs: "col-md-7 col-12",
                  renderBody: function(out) {
                    SearchBar_tag({
                        icon: "bx-user",
                        target: "user",
                        minLength: 3,
                        suggestions: state.suggestions,
                        placeholder: Locale("Find a User")
                      }, out, __component, "3", [
                      [
                        "blur",
                        "onSearchDismiss",
                        false
                      ],
                      [
                        "result",
                        "onSearchResult",
                        false
                      ],
                      [
                        "select",
                        "onSelectSuggestion",
                        false
                      ]
                    ]);
                  }
                }, out, __component, "2");

              WSAdapt_tag({
                  class: "col",
                  renderBody: function(out) {
                    route_link_tag({
                        href: "/user-groups",
                        class: "btn btn-secondary btn-lg float-right m-25",
                        renderBody: function(out) {
                          Locale_tag({
                              text: "Groups"
                            }, out, __component, "6");
                        }
                      }, out, __component, "5");

                    route_link_tag({
                        href: "/user-permissions",
                        class: "btn btn-secondary btn-lg float-right m-25",
                        renderBody: function(out) {
                          Locale_tag({
                              text: "Permissions & Roles"
                            }, out, __component, "8");
                        }
                      }, out, __component, "7");

                    route_link_tag({
                        href: "/add-user",
                        class: "btn btn-primary btn-lg float-right m-25",
                        renderBody: function(out) {
                          Locale_tag({
                              text: "Add User"
                            }, out, __component, "10");
                        }
                      }, out, __component, "9");
                  }
                }, out, __component, "4");

              out.be("div", marko_attrs0, "11", component);

              out.n(marko_node0, component);

              out.n(marko_node1, component);

              Datatable_tag({
                  format: tableFormat,
                  data: state.users,
                  pagination: 10,
                  stripped: true,
                  loading: state.fetching,
                  class: "w-100 theme-bg"
                }, out, __component, "14", [
                [
                  "canload",
                  "fetchUsers",
                  false
                ],
                [
                  "select",
                  ({ _email }) => window.navigate(`/user/${_email}`),
                  false
                ]
              ]);

              out.ee();
            }
          }, out, __component, "1");
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
